"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function reduceKey(subject, callbackfn, initialValue) {
    return Object.keys(subject).reduce(callbackfn, initialValue);
}
exports.reduceKey = reduceKey;
//# sourceMappingURL=reduceKey.js.map